import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 12m-6 0a6 6 0 1 0 12 0a6 6 0 1 0 -12 0","key":"svg-0"}],["path",{"d":"M7 12h11","key":"svg-1"}]]

const IconGenderAgender = createReactComponent('outline', 'gender-agender', 'GenderAgender', __iconNode);

export default IconGenderAgender;